// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

export const getUsersGroupPrivileges = createAsyncThunk('appUsers/getUsersGroupPrivileges',  async id => {
  const response = await axios.get('https://apiv3.opentlv.com/api/v3/users/groups/privileges/all', { params: { id} })
  return response.data
})

export const getUsersGroupPrivilegesData = createAsyncThunk('appUsers/getUsersGroupPrivilegesData', async params => {
  const response = await axios.get('https://apiv3.opentlv.com/api/v3/users/groups/privileges/data', {params})
  return {
    params,
    data: response.data.data,
    totalPages: response.data.total
  }
})

export const getAllDataPrivileges = createAsyncThunk('appUsers/getAllDataPrivileges', async id => {

  console.log("ID")

  console.log(id)
  const response = await axios.get('https://apiv3.opentlv.com/api/v3/users/roles/all')
  return response.data
})

export const getDataPrivileges = createAsyncThunk('appUsers/getData', async params => {
  const response = await axios.get('https://apiv3.opentlv.com/api/v3/users/roles/data', params)
  return {
    params,
    data: response.data,
    totalPages: response.data.total
  }
})
export const addUserToGroup = createAsyncThunk('appUsers/addUserToGroup', async (group, { dispatch, getState }) => {
  //  option.client_id = getState()
    console.log("addUserToGroup")
    
    group.group_id = getState().groupPrivileges.selectedGroup.id
    console.log("addUserToGroup2")

    
    await axios.post('https://apiv3.opentlv.com/api/v3/users/addusertogroup', group)
    await dispatch(getUsersGroupPrivilegesData(getState().groupPrivileges.params))
  
    //await d
  })
export const getUser = createAsyncThunk('appUsers/getUser', async id => {
  const response = await axios.get('https://apiv3.opentlv.com/api/v3/users/user', { params: { id} })
  console.log(response.data)
  return response.data
})

export const addUser = createAsyncThunk('appUsers/addUser', async (user, { dispatch, getState }) => {
  await axios.post('/apps/users/add-user', user)
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return user
})

export const deleteUser = createAsyncThunk('appUsers/deleteUser', async (id, { dispatch, getState }) => {
  await axios.delete('/apps/users/delete', { id })
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return id
})

export const appUsersSlice = createSlice({
  name: 'appUsers',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getUsersGroupPrivileges.fulfilled, (state, action) => {
        state.allData = action.payload
      })
      .addCase(getUsersGroupPrivilegesData.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.selectedUser = action.payload
      })
  }
})

export default appUsersSlice.reducer
